import { render } from "./ConferencesList.vue?vue&type=template&id=b336b754&scoped=true"
import script from "./ConferencesList.vue?vue&type=script&lang=js"
export * from "./ConferencesList.vue?vue&type=script&lang=js"

import "./ConferencesList.vue?vue&type=style&index=0&id=b336b754&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b336b754"]])

export default __exports__